var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-edit',_vm._g(_vm._b({attrs:{"toptitle":"Abrechnungsinformationen bearbeiten","name":"settings-payment-customer-edit","title":_vm.paymentCustomer.name,"width":400}},'base-edit',_vm.$attrs,false),_vm.$listeners),[_c('SettingsPaymentCustomerForm',{attrs:{"paymentCustomer":_vm.paymentCustomer,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }